export default __webpack_public_path__ + "static/media/organizer.5d6ef549.png";